import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgTimezone = Loadable({
  loader: function loader() {
    return import('../OrgTimezone.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgTimezone;